import { useState } from "react";
import { Stack, Shelf, Text } from "@chaser/components";
import { toCurrency } from "../../../../util";
import styles from "../AddonOption.module.scss";

const VolumePricingBlock = ({ tierContext, onSelectTier, currency }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    uniqueTiers,
    currentTierKey,
    minQuantity,
    nextTier,
    quantityToNextTier,
  } = tierContext;

  return (
    <Stack gap="small" className={styles.volumePricingBlock}>
      <button
        className={styles.volumePricingToggle}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <Text className={styles.volumePricingTitle}>VOLUME PRICING</Text>
        {isExpanded ? (
          <svg
            className={styles.volumePricingChevron}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 10L8 6L4 10"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            className={styles.volumePricingChevron}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6L8 10L12 6"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>

      {isExpanded && (
        <>
          <div className={styles.volumeTierTable}>
            <div className={styles.volumeTierHeader}>
              <Text color="Mid Neutral 1" fontSize="small">
                Quantity
              </Text>
              <Text color="Mid Neutral 1" fontSize="small">
                Per credit
              </Text>
            </div>
            {uniqueTiers.map((tier) => {
              const tierKey = `${tier.price}-${tier.startingUnit}`;
              const isCurrentTier = tierKey === currentTierKey;
              const tierLabel = `${tier.startingUnit}${tier.endingUnit ? `-${tier.endingUnit}` : "+"}`;
              const selectTier = () => {
                onSelectTier(Math.max(tier.startingUnit, minQuantity));
              };

              return (
                <Shelf
                  key={tierKey}
                  justifyContent="space-between"
                  className={`${styles.volumeTierRow} ${isCurrentTier ? styles.volumeTierRowCurrent : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={selectTier}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      selectTier();
                    }
                  }}
                >
                  <Shelf gap="xsmall" alignItems="center">
                    <Text>{tierLabel}</Text>
                    {isCurrentTier && (
                      <span className={styles.currentTierPill}>CURRENT</span>
                    )}
                  </Shelf>
                  <Text>{toCurrency(tier.price / 100, currency)}</Text>
                </Shelf>
              );
            })}
          </div>

          {nextTier && quantityToNextTier > 0 && (
            <div className={styles.nextTierHint}>
              <Text color="Orange" fontSize="small">
                Add {quantityToNextTier} more to drop to{" "}
                {toCurrency(nextTier.price / 100, currency)} per credit.
              </Text>
            </div>
          )}
        </>
      )}
    </Stack>
  );
};

export default VolumePricingBlock;
